import { motion, HTMLMotionProps, AnimatePresence } from 'framer-motion'

interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary'
  children: React.ReactNode
  className?: string
  isLoading?: boolean
}

const buttonVariants = {
  loading: {
    scale: 0.9,
    opacity: 0.9,
    transition: { duration: 0.2, ease: 'easeInOut' }
  },
  idle: {
    scale: 1,
    opacity: 1,
    transition: { duration: 0.2, ease: 'easeInOut' }
  }
}

export const Button = ({
  variant = 'primary',
  children,
  className = 'h-12 w-full',
  type = 'button',
  isLoading = false,
  ...props
}: ButtonProps) => {
  const baseStyles = "py-3 px-6 rounded-full font-semibold inline-block text-center text-[0.9375rem] cursor-pointer"
  const variants = {
    primary: "bg-blue-600 text-white active:opacity-90 touch-none",
    secondary: "bg-white text-blue-600 border border-blue-600 active:bg-gray-100 touch-none"
  }

  return (
    <motion.button
      type={type}
      className={`${baseStyles} ${variants[variant]} ${className}`}
      disabled={isLoading}
      variants={buttonVariants}
      animate={isLoading ? "loading" : "idle"}
      exit={isLoading ? "idle" : undefined}
      whileTap={{ scale: 0.98 }}
      {...props}
    >
      <AnimatePresence mode='wait'>
        {isLoading ? (
          <motion.div
            className={`mx-auto w-5 h-5 border-2 border-t-transparent rounded-full ${
              variant === 'secondary' ? 'border-blue-600' : 'border-white'
            }`}
            animate={{ rotate: 360, transition: { repeat: Infinity, duration: 1, ease: 'linear' } }}
          />
        ) : (
          children
        )}
      </AnimatePresence>
    </motion.button>
  )
}

export default Button